// extracted by mini-css-extract-plugin
export var icon = "_4e-1";
export var subtext = "_4e-0";